import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../Common/Logo';

const PUBLIC_FOOTER_LINKS = [
  { page: 'about', label: 'About' },
  { page: 'science', label: 'Science' },
  { page: 'resources', label: 'Resources' },
  { page: 'downloads', label: 'Downloads', external: true },
  { page: 'privacy', label: 'Privacy' },
  { page: 'terms', label: 'Terms' },
  { page: 'help', label: 'Help & User Guidance' },
];

const PublicPageFooter = ({ activePage = '', onNavigateHome, onNavigatePage }) => {
  const scrollToTop = () => {
    const container = document.querySelector('.page-container');
    if (container) {
      container.scrollTo?.({ top: 0, left: 0, behavior: 'smooth' });
      container.scrollTop = 0;
    }
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  const handleDownloadsClick = () => {
    window.location.assign('/downloads/');
  };

  const handleNavigate = (page) => {
    if (typeof onNavigatePage === 'function') {
      onNavigatePage(page);
      return;
    }
    if (typeof onNavigateHome === 'function') {
      onNavigateHome();
    }
  };

  return (
    <footer className="page-footer page-footer--editorial">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-brand">
            <Logo size={28} />
            <span>ThryveLoop</span>
          </div>
          <p className="footer-copyright">
            Track what helps, keep your data private, and choose the next step with less noise.
          </p>
          <p className="footer-copyright">
            © 2026 ThryveLoop. Built for curious minds.
          </p>
        </div>

        <nav className="page-footer-links" aria-label="Footer links">
          {PUBLIC_FOOTER_LINKS.map((item) => (
            <button
              key={item.page}
              type="button"
              className={`footer-link ${activePage === item.page ? 'active' : ''}`}
              onClick={item.external ? handleDownloadsClick : () => handleNavigate(item.page)}
              aria-current={activePage === item.page ? 'page' : undefined}
            >
              {item.label}
            </button>
          ))}
          <button
            type="button"
            className="footer-link back-to-top-link"
            onClick={scrollToTop}
            title="Scroll back to top"
          >
            Back to top
          </button>
        </nav>
      </div>
    </footer>
  );
};

PublicPageFooter.propTypes = {
  activePage: PropTypes.string,
  onNavigateHome: PropTypes.func,
  onNavigatePage: PropTypes.func,
};

export default PublicPageFooter;
